export default __webpack_public_path__ + "static/media/ense.2b709aa9.svg";